export default "__VITE_PUBLIC_ASSET__cada43d0__"